module.exports = __webpack_public_path__ + "static/img/spring_tab3_selected.e6db063.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/newVersion/spring_tab3_selected.png
// module id = 361
// module chunks = 32